import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddBlogDetails.css';
import cs from '../../../components/commonStyle.css';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { graphql, gql, compose } from 'react-apollo';
// Style
import {
  Button,
  Row,
  FormGroup,
  Col,
  ControlLabel
} from 'react-bootstrap';
import { formatURL } from '../../../helpers/formatURL';
import fetch from '../../../core/fetch';
import Link from '../../Link';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../MultiLanguageInput';

//Image
import arrowIcon from '/public/AdminIcons/backArrow.svg';
import { url } from '../../../config';

class AddBlogDetails extends React.Component {

  constructor(props) {
    super(props)
    if (typeof window !== 'undefined') {
      this.ReactQuill = require('react-quill');
      this.Quill = require('quill');
    }
    this.state = { editorHtml: '' } // You can also pass a Quill Delta here
    this.handlePageTitle = this.handlePageTitle.bind(this);
  }


  async handlePageTitle(e) {
    const { change } = this.props;
    if (e.target.value) {
      await change('pageUrl', formatURL(e.target.value));
    } else {
      await change('pageUrl', '');
    }
  }

  handleFieldChange = (fieldName, value) => {
    const { dispatch } = this.props;
    dispatch(change('BlogDetails', fieldName, value));
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
    })),
  };

  static defaultProps = {
    data: []
  };




  renderQuill = ({ input, label, type, meta: { touched, error }, className }) => {
    const ReactQuill = this.ReactQuill;
    const Quill = this.Quill;
    const { formatMessage } = this.props.intl;
    let modules = {
      toolbar: [
        [{ 'header': '1' }, { 'header': '2' }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        ['link'],
        // ['link', 'image'],
      ],
      clipboard: {
        matchVisual: false,
      }
    };

    let formats = [
      'header', 'size',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link'
      // 'link', 'image'
    ];
    return (
      <div>
        <ReactQuill
          {...input}
          onChange={(newValue, delta, source) => {
            if (source === 'user') {
              input.onChange(newValue);
            }
          }}
          onBlur={(range, source, quill) => {
            if (quill.getHTML() == '<p><br></p>') {
              input.onBlur('');
            }
            else {
              input.onBlur(quill.getHTML());
            }

          }}
          placeholder="write something......."
          modules={modules}
          formats={formats}
          theme="snow"
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }


  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, title, siteName, formValues } = this.props;
    const ReactQuill = this.ReactQuill;
    const Quill = this.Quill;
    const { formatMessage } = this.props.intl;
    const gobackcss = { padding: '10px' };
    if (typeof window !== 'undefined' && ReactQuill) {
      return (
        <div className={cx(s.pagecontentWrapper, 'pagecontentWrapperRTL')}>
          <div className={cx(cs.adminContentPadding)}>
            <div className={s.sectionCenter}>
              <div className={cx(cs.textAlignRight, cs.mobileDisplayBlock, 'textAlignLeftRTL', cs.spaceBottom4)}>
                <Link to={'/siteadmin/content-management'} className={cx(cs.siteLinkColor, cs.commonContentText, cs.fontWeightMedium, cs.commomLinkborderBottom, cs.textDecorationNone)}>
                  <img src={arrowIcon} className={cx(cs.backArrowStyle, 'adminGoBackArrowRTL')} />
                  <FormattedMessage {...messages.goBack} />
                </Link>
              </div>
              <div className={cs.commonAdminBorderSection}>
                <h1 className={s.headerTitle}><FormattedMessage {...messages.addPageDetails} /></h1>
                <form onSubmit={handleSubmit(submit)}>
                  {error && <strong>{formatMessage(error)}</strong>}
                  
                  {/* Meta Title - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.metaTitleLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="metaTitle"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="text"
                      placeholder={formatMessage(messages.metaTitleLabel)}
                    />
                  </FormGroup>

                  {/* Meta Description - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.metaDescriptionLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="metaDescription"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="textarea"
                      placeholder={formatMessage(messages.metaDescriptionLabel)}
                    />
                  </FormGroup>

                  {/* Page Title - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.pageTitleLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="pageTitle"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="text"
                      placeholder={formatMessage(messages.pageTitleLabel)}
                    />
                  </FormGroup>

                  {/* Page URL - NOT multilingual */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.pageUrl} />
                    </ControlLabel>
                    <Field name="pageUrl" type="text" isAddon={true} component={CommonFormComponent} suffixLabel={`${url}${formatMessage(messages.pageLabel)}`} label={formatMessage(messages.pageUrl)} inputClass={cx(cs.formControlInput, s.addonInputRadius)} />
                  </FormGroup>

                  {/* Footer Category - NOT multilingual */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.footerCategoryLabel} />
                    </ControlLabel>
                    <Field name="footerCategory" component={CommonFormComponent} inputClass={cx(cs.formControlSelect)} label={formatMessage(messages.footerCategoryLabel)}>
                      <option value="">{formatMessage(messages.ChooseFooterCategory)}</option>
                      <option value={siteName}>{siteName}</option>
                      <option value="discover">{formatMessage(messages.discover)}</option>
                      <option value="hosting">{formatMessage(messages.hosting)}</option>
                    </Field>
                  </FormGroup>

                  {/* Content - Multi-language Rich Text */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cs.labelTextNew}>
                      <FormattedMessage {...messages.contentLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="content"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="rich"
                      placeholder={formatMessage(messages.contentLabel)}
                    />
                  </FormGroup>

                  <FormGroup className={s.noMargin}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                        <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting} ><FormattedMessage {...messages.save} /></Button>
                      </Col>
                    </Row>
                  </FormGroup>
                </form>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <textarea />;
    }
  }

}

AddBlogDetails = reduxForm({
  form: 'BlogDetails', // a unique name for this form
  validate
})(AddBlogDetails);



const blogFormSelector = formValueSelector('BlogDetails');

const getMultiLangFields = (state, baseFields) => {
  const result = {};
  const langs = ['', '_en', '_fr', '_it', '_pt'];
  baseFields.forEach(field => {
    langs.forEach(lang => {
      const fieldName = `${field}${lang}`;
      result[fieldName] = blogFormSelector(state, fieldName);
    });
  });
  return result;
};

const mapState = (state) => ({
  pageTitle: blogFormSelector(state, 'pageTitle'),
  pageURL: blogFormSelector(state, 'pageUrl'),
  siteName: state.siteSettings.data.siteName,
  formValues: getMultiLangFields(state, ['metaTitle', 'metaDescription', 'pageTitle', 'content'])
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(AddBlogDetails)));